import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { TYPE_META } from "./GuestCard";

const TYPES = [["large", "Large Gazebo"], ["medium", "Medium Gazebo"], ["small", "Small Gazebo"], ["umbrella", "Umbrella"]];

export const AddSpotDialog = ({ open, onOpenChange, onAdd }) => {
  const [type, setType] = useState("small");
  const [num, setNum] = useState("");

  const submit = () => {
    onAdd({ type, num: num ? Number(num) : undefined });
    onOpenChange(false);
    setNum("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="add-spot-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl tracking-wide">Add a spot</DialogTitle>
          <DialogDescription className="sr-only">Add a new gazebo or umbrella to the beach layout.</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-slate-500">Add a new gazebo or umbrella if you build more spaces on the beach.</p>

        <div className="mt-2">
          <p className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500">Type</p>
          <div className="grid grid-cols-2 gap-2">
            {TYPES.map(([v, l]) => (
              <button
                key={v}
                data-testid={`spot-type-${v}`}
                onClick={() => setType(v)}
                className={`flex items-center gap-2 rounded-xl border px-3 py-2 text-sm font-semibold transition-colors ${type === v ? "border-slate-900 bg-slate-900 text-white" : "border-sand-300 bg-white text-slate-600 hover:border-slate-400"}`}
              >
                <span className={`h-2.5 w-2.5 rounded-full ${TYPE_META[v].dot}`} /> {l}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-3">
          <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-slate-500">Number (optional)</p>
          <Input
            data-testid="spot-num-input"
            value={num}
            onChange={(e) => setNum(e.target.value.replace(/\D/g, ""))}
            placeholder="Leave empty to auto-number"
            className="h-9"
          />
        </div>

        <button
          data-testid="spot-add-btn"
          onClick={submit}
          className="mt-4 h-10 w-full rounded-lg bg-brand text-sm font-semibold text-white hover:bg-brand-600"
        >
          Add spot
        </button>
      </DialogContent>
    </Dialog>
  );
};
